import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import ObjectGenerator from '../SimsMode/ObjectGenerator.js';

export default class Config{
	constructor(currentEnv, roomName, roomConfig, whereToAddObjects, data) {
		this.simsData = {canMove: true, visible: true, added: false, id: 0, moved: false, basePos:{x: 0, y: 0, z: 0}, rotated: false, baseRot:{x: 0, y: 0, z: 0}};

		this.currentEnv = currentEnv;
		this.roomName = roomName;
		this.roomConfig = roomConfig;
		this.data = {};

		this.whereToAddObjects  = whereToAddObjects;
		this.distanceObject = this.currentEnv.getObjectByName("Distance_" + this.roomName);
		this.delimZones = this.currentEnv.getObjectByName("Delimitations_" + this.roomName);

		this.objectGenerator = new ObjectGenerator();
	}

	SetSimsDataFunction(fun) {
		this.simsDataFunction = fun;
	}

	SetupDelimData(refDelim) {
		var zoneDelimData;
		switch(this.roomConfig) {
				case "1":
				case "2":
				case "3":
				case "4":
				case "5":
				case "11":
				case "Lully":
					zoneDelimData = {};
					zoneDelimData.maxX = 0;
					zoneDelimData.minX = 0;
					zoneDelimData.maxZ = 0;
					zoneDelimData.minZ = 0;

					for(var i = 0; i < refDelim.children.length; i++) {
						if (zoneDelimData.maxX == 0 || refDelim.children[i].position.x > zoneDelimData.maxX) {
							zoneDelimData.maxX = refDelim.children[i].position.x;
						}
						if (zoneDelimData.minX == 0 || refDelim.children[i].position.x < zoneDelimData.minX) {
							zoneDelimData.minX = refDelim.children[i].position.x;
						}
						if (zoneDelimData.maxZ == 0 || refDelim.children[i].position.z > zoneDelimData.maxZ) {
							zoneDelimData.maxZ = refDelim.children[i].position.z;
						}
						if (zoneDelimData.minZ == 0 || refDelim.children[i].position.z < zoneDelimData.minZ) {
							zoneDelimData.minZ = refDelim.children[i].position.z;
						}
					}
					break;
				case "1_2":
				case "2_3":
				case "1_2_3":
				case "6":
				case "7":
				case "8":
				case "9":
				case "10":
					zoneDelimData = [];
					for (var n = 0; n < refDelim.children.length; n++) {
						zoneDelimData.push({});
						zoneDelimData[n].maxX = 0;
						zoneDelimData[n].minX = 0;
						zoneDelimData[n].maxZ = 0;
						zoneDelimData[n].minZ = 0;

						for(var i = 0; i < refDelim.children[n].children.length; i++) {
							if (zoneDelimData[n].maxX == 0 || refDelim.children[n].children[i].position.x > zoneDelimData[n].maxX) {
								zoneDelimData[n].maxX = refDelim.children[n].children[i].position.x;
							}
							if (zoneDelimData[n].minX == 0 || refDelim.children[n].children[i].position.x < zoneDelimData[n].minX) {
								zoneDelimData[n].minX = refDelim.children[n].children[i].position.x;
							}
							if (zoneDelimData[n].maxZ == 0 || refDelim.children[n].children[i].position.z > zoneDelimData[n].maxZ) {
								zoneDelimData[n].maxZ = refDelim.children[n].children[i].position.z;
							}
							if (zoneDelimData[n].minZ == 0 || refDelim.children[n].children[i].position.z < zoneDelimData[n].minZ) {
								zoneDelimData[n].minZ = refDelim.children[n].children[i].position.z;
							}
						}
					}
					break;
			}

		return zoneDelimData;
	}

	CreateDistances(distanceObject) {
		this.ClearLines();
		var text = "";
		var pointA, pointB;
		var regex = /.*0[0-9][1-9]/;
		for(var i = 0; i < distanceObject.children.length; i++) {
			if (!regex.test(distanceObject.children[i].name) || pointA == null) {
				pointA = distanceObject.children[i].position;
				text = distanceObject.children[i].name;
			}
			else {
				pointB = distanceObject.children[i].position;
				this.CreateLine(pointA, pointB, text);
				pointA = null;
				pointB = null;
				text = "";
			}
		}
	}

	CreateLine(pointA, pointB, text) {
		var geometry = new THREE.BufferGeometry().setFromPoints([pointA, pointB]);
		var material = new THREE.LineBasicMaterial({ color: 0xffffff });
		var line = new THREE.Line(geometry, material);
		line.name = "Line";
		this.whereToAddObjects.add(line);

		var cutIndex = text.indexOf("m");
		var strResult = cutIndex !== -1 ? text.substring(0, cutIndex + 1) : text;

		const fontLoader = new THREE.FontLoader();
		fontLoader.load('fonts/helvetiker_regular.typeface.json', function (font) {
			const textGeometry = new THREE.TextGeometry(strResult, {
				font: font,
				size: 0.5, // Taille du texte
				height: 0.01, // Hauteur du texte
				curveSegments: 12, // Nombre de segments de courbe pour la géométrie
				bevelEnabled: false // Activation de l'effet de chanfrein
			});

			// Création du matériau pour le texte
			const material = new THREE.MeshBasicMaterial({ color: 0xffffff });

			// Création de l'objet texte
			const textMesh = new THREE.Mesh(textGeometry, material);

			const boundingBox = new THREE.Box3();
			boundingBox.setFromObject(textMesh);

			// Obtenir les dimensions de la boîte englobante (largeur, hauteur, profondeur)
			const size = new THREE.Vector3();
			boundingBox.getSize(size);

			const centerPoint = new THREE.Vector3();
			centerPoint.lerpVectors(pointA, pointB, 0.5);
			textMesh.position.set(centerPoint.x, centerPoint.y, centerPoint.z);

			if (this.fpsView) {
				if (pointA.z != pointB.z) {
					textMesh.rotation.x = 0;
					if (this.currentRoom == "1" || this.currentRoom == "3") {
						textMesh.rotation.y = Math.PI/2;
					}
					else {
						textMesh.rotation.y = -Math.PI/2;
					}
					textMesh.rotation.z = 0;
				}
				else {
					textMesh.rotation.x = 0;
				}

				textMesh.translateY(-0.5);
			}
			else {
				if (pointA.y != pointB.y) {
					textMesh.rotation.z = -Math.PI/2;
					textMesh.translateX(-boundingBox.max.x / 2);
				}
				else  {
					if (pointA.z != pointB.z) {
						if (this.currentRoom == "1" || this.currentRoom == "3") {
							textMesh.rotation.z = Math.PI/2;
						}
						else {
							textMesh.rotation.z = -Math.PI/2;
						}
					}
					textMesh.rotation.x = -Math.PI/2;
				}
				textMesh.translateY(0.1);
			}
			textMesh.name = "Text";
			// Ajout du texte à la scène
			this.whereToAddObjects.add(textMesh);
		}.bind(this));
	}

	ClearLines() {
		for(var i = this.whereToAddObjects.children.length - 1; i >= 0 ; i--) {
			if (this.whereToAddObjects.children[i].name == "Line" || this.whereToAddObjects.children[i].name == "Text") {
				this.whereToAddObjects.remove(this.whereToAddObjects.children[i]);
			}
		}
	}

	IsInZone(zoneDelimData, newPos) {
		if (zoneDelimData.length) {
			for (var i = 1; i < zoneDelimData.length; i++) {
				var xOK = (newPos.posX < zoneDelimData[i].maxX && newPos.posX > zoneDelimData[i].minX)
				var zOK = (newPos.posZ < zoneDelimData[i].maxZ && newPos.posZ > zoneDelimData[i].minZ)

				if (xOK && zOK) {
					return true;
				}
			}
		}

		return false;
	}

	GetData() {
		return this.data;
	}

	HideObjectAdded(list, id) {
		for(var i = id; i < list.length; i++) {
			list[i].visible = false;
		}
	}
	
	DropAllObjectAdded() {
		while(this.whereToAddObjects.children.length > 0) {
			this.whereToAddObjects.remove(this.whereToAddObjects.children[0]);
		}

		this.refTable = null;
		this.refChaise = null;
		this.refPraticable = null;
		this.refCocktail = null;
		this.refBuffet = null;
		this.refPole = null;
		this.refGrandEcran = null;
		this.refPlafonnier = null;
		this.refTableRonde = null;
	}
}